const isArray = (data) => Array.isArray(data)

const isObject = (data) => {
  return data instanceof Object && !Array.isArray(data)
}

export { isArray, isObject }
